module.exports = __webpack_public_path__ + "img/Logo_edese_hd(2).ceaae8a8.png";